// 32/16/8-bit integer discipline helpers — the typed-int layer every determinism-critical
// module uses instead of raw JS arithmetic (see tasks/typescript-port.md, risk register).
// JS numbers are doubles; these helpers pin C++ integer semantics exactly.

/** C++ (int) — wrap to signed 32-bit. */
export const i32 = (n: number): number => n | 0;

/** C++ (dword/unsigned) — wrap to unsigned 32-bit. */
export const u32 = (n: number): number => n >>> 0;

/** C++ store-to-short truncation (WCoord/TCoord/fix are signed 16-bit). */
export const s16 = (n: number): number => (n << 16) >> 16;

/** C++ store-to-word truncation (Gid etc. are unsigned 16-bit). */
export const u16 = (n: number): number => n & 0xffff;

/** C++ store-to-char truncation (-fsigned-char: char/Direction are signed 8-bit). */
export const s8 = (n: number): number => (n << 24) >> 24;

/** C++ 32-bit integer division: truncate toward zero (NOT Math.floor for negatives). */
export const idiv = (a: number, b: number): number => (a / b) | 0;
